import styled, { css } from 'styled-components';
import { CHART_TICK_COLOR, HEAT_GRADIENT_COLORS, TEXT_PRIMARY, TEXT_MUTED, TEXT_PLACEHOLDER } from '../consts';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%; /* fill the fixed-height module container */
  min-height: 0; /* allow children to shrink within it */
`;

export const ChartWrapper = styled.div`
  width: 100%;
  flex: 1 1 auto; /* grow/shrink to fill the space left after the legend */
  min-height: 0; /* THE fix: lets the chart shrink below its content in a flex column */
`;

export const LegendContainer = styled.div`
  flex-shrink: 0; /* keep natural height; never get squeezed out of view */
  display: grid;
  grid-template-columns: minmax(0, 2fr) 1fr; /* bar (2/3) | empty (1/3) */
  align-items: center;
  column-gap: 0.5rem;
  row-gap: 0.25rem;
  margin-top: 1rem;
  padding-left: 10px;
  font-size: 12px;
  color: ${CHART_TICK_COLOR};
`;

export const LegendLabel = styled.span`
  grid-column: 1 / -1; /* own line, above the bar */
  white-space: nowrap;
`;

export const LegendGradient = styled.div`
  grid-area: 2 / 1; /* row 2, bar column */
  height: 8px;
  border-radius: 4px;
  background: linear-gradient(
    to right,
    ${HEAT_GRADIENT_COLORS[0]},
    ${HEAT_GRADIENT_COLORS[1]},
    ${HEAT_GRADIENT_COLORS[2]},
    ${HEAT_GRADIENT_COLORS[3]}
  );
`;

export const LegendTicks = styled.div`
  grid-area: 3 / 1; /* row 3, under the bar */
  display: flex;
  justify-content: space-between;
`;

export const TooltipBox = styled.div`
  ${({ theme: { colors } }) => css`
    background: ${colors.brandLight};
    font-size: 0.75rem;
    border-radius: 0.375rem;
    border: 1px solid ${colors.brandDarkTint90};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 0.5rem 0.625rem;
  `}
`;

export const TooltipTitle = styled.div`
  font-weight: 600;
  color: ${TEXT_PRIMARY};
`;

export const TooltipValue = styled.div`
  color: ${TEXT_MUTED};
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  color: ${TEXT_PLACEHOLDER};
  font-size: 0.875rem;
`;
